import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import { useFormik } from "formik"
import * as Yup from "yup"
import {
  resetForgetPasswordMessages,
  userForgetPassword,
} from "../../store/actions"
import profile from "../../assets/images/profile-img.png"
import logo from "../../assets/images/logo.svg"
import "./Login.css"

const ForgetPasswordPage = props => {
  document.title = "Esqueci a senha | Leads Plataform - Blops"

  const [formSubmitted, setFormSubmitted] = useState(false)
  const dispatch = useDispatch()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Por Favor informe seu Email")
        .test(
          "caracteres-antes",
          'Mínimo de 3 caracteres antes do "@"',
          value =>
            (value ?? "").includes("@") && value.split("@")[0].length >= 3
        )
        .test("inclusao-simbolo", 'Email deve incluir o "@"', value =>
          (value ?? "").includes("@")
        )
        .test(
          "caracteres-depois",
          'Mínimo de 3 caracteres após o "@"',
          value =>
            (value ?? "").includes("@") && value.split("@")[1].length >= 3
        )
        .test(
          "ponto-depois-arroba",
          'Deve haver um ponto após o "@" com pelo menos dois caracteres depois',
          value => {
            const atIndex = value.indexOf("@")
            if (atIndex === -1) return false
            const dotIndex = value.indexOf(".", atIndex)
            const charsAfterDot =
              dotIndex > -1 ? value.substring(dotIndex + 1).length : 0
            return dotIndex > -1 && dotIndex > atIndex && charsAfterDot >= 2
          }
        ),
    }),
    onSubmit: async (values, { resetForm }) => {
      setFormSubmitted(true)
      await dispatch(userForgetPassword(values, props.history))
      resetForm()
    },
  })

  const { forgetError, forgetSuccessMsg } = useSelector(state => ({
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
  }))

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(resetForgetPasswordMessages())

      if (forgetSuccessMsg) {
        props.history.push("/login")
        setFormSubmitted(false)
      }
    }, 3000)

    return () => clearTimeout(timeout)
  }, [forgetError, forgetSuccessMsg, dispatch])

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-softbg-soft-primary">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Bem vindo novamente!</h5>
                        <p>Faça Login para acessar a Plataforma Leads.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError.response.data}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}

                    <Form
                      className="form-horizontal"
                      onSubmit={validation.handleSubmit}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md custon-btn-forget"
                            type="submit"
                            disabled={
                              formSubmitted ||
                              validation.values.email === "" ||
                              !validation.isValid ||
                              (forgetError &&
                                forgetError.response &&
                                forgetError.response.data)
                            }
                          >
                            Enviar
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Voltar para o{" "}
                  <Link to="login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Leads Plataform. Desenvolvido com{" "}
                  <i className="mdi mdi-heart text-danger" /> por MRP Solution
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
